module.exports = __webpack_public_path__ + "img/WCS-India_logo.c963b404.png";